import { Button, ButtonStyles, FloatingSnackbar, List, ListItem, ThemesNames } from '@silverfort/sf-components';
import { FC } from 'react';

interface BulkAction {
    key: string;
    label: string;
    onClick: () => void;
    disabled?: boolean;
}

interface BulkActionsProps<T> {
    selectedItems: T[];
    onClose: () => void;
    actions: BulkAction[];
    menuActions?: BulkAction[];
    selectionText: {
        singular: string;
        plural: string;
    };
}

const BulkActions = <T,>({
    selectedItems,
    onClose,
    actions,
    menuActions,
    selectionText
}: BulkActionsProps<T>): JSX.Element => {
    return (
        <FloatingSnackbar
            menuContent={
                menuActions && menuActions.length > 0 ? (
                    <List theme={ThemesNames.Dark}>
                        {menuActions.map((action) => (
                            <ListItem
                                key={action.key}
                                theme={ThemesNames.Dark}
                                title={action.label}
                                onClick={action.onClick}
                                disabled={action.disabled}
                            />
                        ))}
                    </List>
                ) : undefined
            }
            onClose={onClose}
            open={selectedItems.length > 0}
            selectionText={selectionText}
            selections={selectedItems.length}>
            <>
                {actions.map((action) => (
                    <Button
                        key={action.key}
                        disabled={action.disabled}
                        className={action.disabled ? `text-sf-gray-700 bg-transparent border-sf-gray-700` : undefined}
                        buttonStyle={ButtonStyles.Ghost}
                        iconSize={16}
                        onClick={action.onClick}
                        text={action.label}
                    />
                ))}
            </>
        </FloatingSnackbar>
    );
};

export default BulkActions;
export type { BulkAction, BulkActionsProps };
